import {Injectable} from '@angular/core';
import {Observable, of, throwError} from 'rxjs';
import {catchError, switchMap} from 'rxjs/operators';
import {Router} from '@angular/router';
import {FirebaseAuthService} from '../../../networking/services/customer/firebase-auth.service';
import {CustomerManager} from '../customer/customer.manager';
import {LocationManager} from '../../location/location.manager';
import { FirebaseAuthResponse } from 'src/app/data/networking/models/firebase/response/flags';

@Injectable({
  providedIn: 'root',
})
export class FirebaseAuthManager {
  constructor(private firebaseAuthService: FirebaseAuthService,
              private customerManager: CustomerManager,
              private locationManager: LocationManager,
              private router: Router) { }

  createUserWithEmailAndPassword(data): Observable<any> {
    return this.firebaseAuthService.createUserWithEmailAndPassword(data);
  }

  private getSocialToken(provider: string, response: FirebaseAuthResponse): string {
    switch (provider) {
      case 'GOOGLE':
        return response.credential.idToken;
      case 'APPLE':
        return response.user.uid;
      default:
        return response.credential.accessToken
    }
  } 

  fetchFirebaseData(data, signUp = false): Observable<any> {
    let email: string = '';
    let dataInfo = data;
    const reqData = {
      provider: data.registeredBy,
    };
    return this.firebaseAuthService.fetchFirebaseData(reqData)
      .pipe(switchMap((response: FirebaseAuthResponse) => {
        email = response?.user?.providerData[0].email;
        if (response?.additionalUserInfo && !response.additionalUserInfo.isNewUser) {
          dataInfo = {
            ...data,
            deliveryType: this.locationManager.getDeliveryType(),
            uidFirebase: response.user.uid,
            email: response.user.email || response.additionalUserInfo?.profile?.email ,
            token: this.getSocialToken(data.registeredBy, response)
          };
        }
        return of(response);
      }),
      catchError(error => {
        if (error.code === 'auth/account-exists-with-different-credential') {
          if (reqData.provider === 'FACEBOOK') {
            dataInfo = {
              ...data,
              provider: data.registeredBy,
              deliveryType: this.locationManager.getDeliveryType(),
              ...error,
              token: error.credential.accessToken,
            };
            return of(dataInfo);
          }
          return of(error);
        }
        return throwError(error);
      }),
      switchMap(res => {
        if (signUp) {
          return of(res);
        }
        return this.customerManager.login(dataInfo)
          .pipe(catchError(error => {
            const errorInfo = {...error, ...dataInfo};
            if (error.code >= 400 && error.code < 500 && error.message.toLowerCase().indexOf('no encontrado') < 0) {
              return of(res);
            }
            throw ({...errorInfo, email});
          }));
      }));
  }
}
